module.exports = __webpack_public_path__ + "static/img/aff4.cfee0031.png";